import React from "react";
import PropTypes from "prop-types";
import {FaSolidIcon} from "../../../FontAwesomeIcons";
import moment from "moment";

export function VideoMessage({isMine, isLast, messageData, getMediaContentUrlAPI}) {
    const sendTime = moment(messageData.data_creazione).format('HH:mm');
    const mediaUrl = getMediaContentUrlAPI(messageData.id_messaggio);
    const videoStyle = {
        maxWidth: 300,
        borderRadius: 15
    }
    return (
        <React.Fragment>
            <div className={"d-flex " + (isMine ? 'justify-content-end mine' : 'yours')}>
                <div className={"message " + (isLast ? 'last' : '')}>
                    <video className={"mb-2"} controls={true} style={videoStyle}>
                        <source src={mediaUrl} type={messageData.metadata.mime_type}/>
                        Your browser does not support the video element.
                    </video>
                    <div className={"metadata"}>
                        {sendTime}&nbsp;
                        {
                            isMine &&
                            <FaSolidIcon name={messageData.letto === '1' ? 'check-double' : 'check'}/>
                        }
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}

VideoMessage.propTypes = {
    isMine: PropTypes.bool,
    isLast: PropTypes.bool,
    messageData: PropTypes.object.isRequired,
    getMediaContentUrlAPI: PropTypes.func.isRequired,
}